import { NgClass } from '@angular/common';
import { Component, ElementRef, Host, NO_ERRORS_SCHEMA, QueryList, ViewChildren } from '@angular/core';
import { DeviceBaseComponent } from '../../../device-base/device-base.component';

@Component({
  selector: 'app-polycom-vvx-color',
  standalone: true,
  templateUrl: './polycom-vvx-color.component.html',
  styleUrls: ['../../../device-base/device-base.component.scss'],
  imports: [NgClass],
  schemas: [NO_ERRORS_SCHEMA],
})
export class PolycomVvxColorComponent {
  @ViewChildren('lineKeyButton') lineKeyButtons!: QueryList<ElementRef>;

  public readonly buttonsCount = 84;
  public readonly isPagingAvailable = true;

  constructor(@Host() public base: DeviceBaseComponent) {}

  getLineKeyButtons(): ElementRef<SVGPathElement>[] {
    return this.lineKeyButtons.toArray();
  }
}
